import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderLoginBtnStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginBtn: {
      border: 'none',
      borderRadius: '20px',
      color: theme.palette.common.white,
      padding: 0,
      lineHeight: 2.4,
      fontSize: '16px',
      width: '100%',
      display: 'block',
      background: theme.palette.secondary.main,
      cursor: 'pointer'
    }
  })
)
